var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLeftSLine = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 16,
  viewBox: "0 0 17 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.28404 8.00047L10.5839 11.3003L9.6411 12.2431L5.39844 8.00047L9.6411 3.75781L10.5839 4.70062L7.28404 8.00047Z",
  fill: "#1E1F2F"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLeftSLine);
export { ForwardRef as ReactComponent };